<div id="lnr-profile-created-root">
  <ng-content select="[header]"></ng-content>
  <div class="profile-area">
    <div class="profile-header">
      <ng-content select="[profileHeader]"></ng-content>
    </div>
    <div class="profile-info">
      <div class="text">
        <ng-content select="[welcome]"></ng-content>
      </div>
      <div class="image">
        <ng-content select="[image]"></ng-content>
      </div>
    </div>

    <div class="button-section">
      <ng-content select="[buttonSection]"></ng-content>
    </div>
  </div>
</div>
